module.exports = __webpack_public_path__ + "12982eea1e054d025661de32fd614261.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_variable_x1_variable/public/picture/vancover_canucks.jpg
// module id = 448
// module chunks = 0